module.exports = __webpack_public_path__ + "static/media/ic_video_on_disable.318cfeae.svg";